import * as tslib_1 from "tslib";
import { EntityStore, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
let CartStateStore = class CartStateStore extends EntityStore {
    constructor() {
        super();
    }
};
CartStateStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CartStateStore_Factory() { return new CartStateStore(); }, token: CartStateStore, providedIn: "root" });
CartStateStore = tslib_1.__decorate([
    StoreConfig({ name: 'cart' })
], CartStateStore);
export { CartStateStore };
